import { PlayerProfile } from '../types/skillProgress';

export const samplePlayers: PlayerProfile[] = [
  {
    userId: 'player_1',
    displayName: 'Sarah Johnson',
    email: 'sarah.johnson@email.com',
    location: 'Austin, TX',
    club: 'Austin Pickleball Club',
    skillLevel: 'intermediate',
    playingStyle: 'all-around',
    availability: ['Monday', 'Wednesday', 'Friday', 'Saturday'],
    preferredTimes: ['Morning (8-11 AM)', 'Evening (6-8 PM)'],
    maxDistance: 15,
    bio: 'Love playing pickleball and meeting new people! Always up for a friendly game.',
    profilePhoto: '👩',
    isActive: true,
    lastActive: new Date().toISOString(),
    totalMatches: 45,
    winRate: 62,
    averageRating: 4.2
  },
  {
    userId: 'player_2',
    displayName: 'Mike Chen',
    email: 'mike.chen@email.com',
    location: 'Austin, TX',
    club: 'Austin Pickleball Club',
    skillLevel: 'advanced',
    playingStyle: 'power',
    availability: ['Tuesday', 'Thursday', 'Saturday', 'Sunday'],
    preferredTimes: ['Morning (7-10 AM)', 'Afternoon (2-5 PM)'],
    maxDistance: 20,
    bio: 'Competitive player looking for challenging matches. Former tennis player.',
    profilePhoto: '👨',
    isActive: true,
    lastActive: new Date().toISOString(),
    totalMatches: 78,
    winRate: 71,
    averageRating: 4.6
  },
  {
    userId: 'player_3',
    displayName: 'Lisa Rodriguez',
    email: 'lisa.rodriguez@email.com',
    location: 'Austin, TX',
    club: 'South Austin Pickleball',
    skillLevel: 'beginner',
    playingStyle: 'control',
    availability: ['Monday', 'Wednesday', 'Friday'],
    preferredTimes: ['Morning (9-11 AM)', 'Evening (5-7 PM)'],
    maxDistance: 10,
    bio: 'New to pickleball but loving it! Looking for patient partners to learn with.',
    profilePhoto: '👩',
    isActive: true,
    lastActive: new Date().toISOString(),
    totalMatches: 12,
    winRate: 33,
    averageRating: 3.8
  },
  {
    userId: 'player_4',
    displayName: 'David Thompson',
    email: 'david.thompson@email.com',
    location: 'Round Rock, TX',
    club: 'Round Rock Pickleball Association',
    skillLevel: 'intermediate',
    playingStyle: 'all-around',
    availability: ['Tuesday', 'Thursday', 'Saturday', 'Sunday'],
    preferredTimes: ['Morning (8-11 AM)', 'Evening (6-8 PM)'],
    maxDistance: 25,
    bio: 'Friendly player who enjoys both competitive and casual games. Great for doubles!',
    profilePhoto: '👨',
    isActive: true,
    lastActive: new Date().toISOString(),
    totalMatches: 56,
    winRate: 58,
    averageRating: 4.1
  },
  {
    userId: 'player_5',
    displayName: 'Emma Wilson',
    email: 'emma.wilson@email.com',
    location: 'Cedar Park, TX',
    club: 'Cedar Park Pickleball',
    skillLevel: 'advanced',
    playingStyle: 'control',
    availability: ['Monday', 'Wednesday', 'Friday', 'Saturday'],
    preferredTimes: ['Morning (7-10 AM)', 'Afternoon (1-4 PM)'],
    maxDistance: 30,
    bio: 'Experienced player who loves teaching and playing with all skill levels.',
    profilePhoto: '👩',
    isActive: true,
    lastActive: new Date().toISOString(),
    totalMatches: 89,
    winRate: 68,
    averageRating: 4.5
  },
  {
    userId: 'player_6',
    displayName: 'James Brown',
    email: 'james.brown@email.com',
    location: 'Austin, TX',
    club: 'Austin Pickleball Club',
    skillLevel: 'beginner',
    playingStyle: 'power',
    availability: ['Saturday', 'Sunday'],
    preferredTimes: ['Morning (9-12 PM)', 'Afternoon (2-5 PM)'],
    maxDistance: 15,
    bio: 'Weekend warrior! Just started playing and looking for regular partners.',
    profilePhoto: '👨',
    isActive: true,
    lastActive: new Date().toISOString(),
    totalMatches: 8,
    winRate: 25,
    averageRating: 3.5
  },
  {
    userId: 'player_7',
    displayName: 'Maria Garcia',
    email: 'maria.garcia@email.com',
    location: 'Pflugerville, TX',
    club: 'Pflugerville Pickleball',
    skillLevel: 'intermediate',
    playingStyle: 'all-around',
    availability: ['Tuesday', 'Thursday', 'Saturday'],
    preferredTimes: ['Morning (8-11 AM)', 'Evening (6-8 PM)'],
    maxDistance: 20,
    bio: 'Passionate about pickleball! Love the social aspect and competitive spirit.',
    profilePhoto: '👩',
    isActive: true,
    lastActive: new Date().toISOString(),
    totalMatches: 34,
    winRate: 59,
    averageRating: 4.0
  },
  {
    userId: 'player_8',
    displayName: 'Robert Davis',
    email: 'robert.davis@email.com',
    location: 'Austin, TX',
    club: 'Austin Pickleball Club',
    skillLevel: 'advanced',
    playingStyle: 'power',
    availability: ['Monday', 'Wednesday', 'Friday', 'Sunday'],
    preferredTimes: ['Morning (7-10 AM)', 'Evening (5-8 PM)'],
    maxDistance: 12,
    bio: 'Tournament player looking for high-level practice partners.',
    profilePhoto: '👨',
    isActive: true,
    lastActive: new Date().toISOString(),
    totalMatches: 112,
    winRate: 74,
    averageRating: 4.7
  }
];
